import { render, staticRenderFns } from "./gatewayPlate.vue?vue&type=template&id=3964cab8&scoped=true&"
import script from "./gatewayPlate.vue?vue&type=script&lang=js&"
export * from "./gatewayPlate.vue?vue&type=script&lang=js&"
import style0 from "./gatewayPlate.vue?vue&type=style&index=0&id=3964cab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964cab8",
  null
  
)

export default component.exports